import { useStoreSelector } from '../../../../../core/store/selector.js';
import { MultiMeterBarChartStore } from '../../context/MultiMeterBarChartStore.js';
import { MultiMeterBarChartState } from '../../types/state.js';

export const useSelector = <T>(
  selector: (state: MultiMeterBarChartState) => T,
): T => useStoreSelector(MultiMeterBarChartStore, selector);
